import React from 'react';

const ManifestoSection = ({ id }) => {
  return (
    <section id={id} className="manifesto-section section-container">
      <div className="section-header">
        <h2 className="section-title">Manifiesto</h2>
      </div>

      <div className="manifesto-content">
        <h3 className="manifesto-brand">The Keeper Lab</h3>

        <div className="manifesto-body">
          <p className="manifesto-opening">
            El arco no es un lugar cualquiera en la cancha.<br />
            <span className="highlight">Es el lugar donde se decide todo.</span>
          </p>

          <div className="manifesto-truths">
            <p>Es donde el error pesa más.</p>
            <p>Donde el silencio es más largo.</p>
            <p>Donde la responsabilidad no se comparte.</p>
          </div>

          <p className="manifesto-statement highlight">
            Nosotros hemos vivido el arco desde dentro.
          </p>

          <div className="manifesto-journey">
            <p>Desde realidades distintas.</p>
            <p>Desde caminos distintos.</p>
            <p>Pero con la misma verdad.</p>
          </div>

          <div className="manifesto-understanding">
            <p>Sabemos lo que significa estar solos bajo los tres palos.</p>
            <p>Sabemos lo que significa fallar y sentir que el mundo se detiene.</p>
            <p>Sabemos lo que significa salvar y que el equipo respire.</p>
          </div>

          <div className="manifesto-elite">
            <p>Sabemos también lo que cuesta llegar a la élite.</p>
            <p>Lo que exige mantenerse.</p>
            <p>Lo que implica sostener el nivel cuando todos esperan perfección.</p>
          </div>

          <p className="manifesto-realization highlight">
            El arquero necesita algo diferente.
          </p>

          <div className="manifesto-needs">
            <p>No solo un contrato.</p>
            <p>No solo una oportunidad.</p>
            <p className="emphasis">Necesita estructura.</p>
            <p className="emphasis">Necesita comprensión.</p>
            <p className="emphasis">Necesita alguien que defienda al que defiende.</p>
          </div>

          <div className="manifesto-birth">
            <p>Durante años lo conversamos.</p>
            <p>Después de partidos.</p>
            <p>Después de títulos.</p>
            <p>Después de derrotas.</p>
          </div>

          <p className="manifesto-conviction highlight">
            El puesto más exigente del fútbol no puede seguir siendo representado de forma estándar.
          </p>

          <p className="manifesto-mission">
            The Keeper Lab nace de esa convicción.
          </p>

          <div className="manifesto-purpose">
            <p>No para representar jugadores.</p>
            <p className="highlight">Sino para acompañar guardianes.</p>
          </div>

          <div className="manifesto-beliefs">
            <p>Creemos que el arquero no necesita más ruido.</p>
            <p className="emphasis">Necesita respaldo.</p>
            <p>No necesita más exposición.</p>
            <p className="emphasis">Necesita estructura.</p>
          </div>

          <p className="manifesto-closing highlight">
            Porque el último en la línea no debería estar solo fuera de ella.
          </p>

          <div className="manifesto-signature">
            <p>— Edgar Merino & Christiane Endler</p>
            <p className="signature-brand">The Keeper Lab</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;
